module.exports = __webpack_public_path__ + "static/media/groups.536b8178.svg";